import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Gate de rota por role de tela. A rota declara `data: { role: 'MENU_X' }` e o acesso exige
 * `MENU_X_SHOW` (mesma regra do menu, incluindo o grandfather/legado vigente). Quem digita a URL
 * sem a role do menu volta para a Home. Não cria role nova: usa as roles já existentes no catálogo.
 */
@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.check(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.check(childRoute);
  }

  private check(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const role = route.data?.['role'] as string | undefined;
    if (!role) return true;
    if (this.authService.isShow({ role })) return true;
    return this.router.createUrlTree(['/home-cards']);
  }
}
